<template>
    <FormComponent
        :label="label"
        :label-inset="labelInset"
        :prefix="prefix"
        :suffix="suffix"
        :focused="focused"
        :required="required"
        :disabled="disabled"
        :is-invalid="isInvalid"
        :is-success="isSuccess"
        @focus="setFocus"

    >
        <input
            class="appearance-none w-full block outline-none bg-transparent relative left-0 right-0 top-0 bottom-0 rounded duration-300 transition-colors"
            :class="{
                'text-gray-500': !focused,
            }"
            ref="input"
            :type="type"
            :id="id"
            :minlength="min"
            :maxlength="max"
            :required="required"
            :readonly="readonly"
            :placeholder="placeholder"
            :disabled="disabled"
            :list="!!suggestions ? 'suggestion-list-' + label : null"
            v-model="inputEditor"
            @focus="handleFocus"
            @blur="handleBlur"
        />
        <datalist v-if="!!suggestions" :id="'suggestion-list-' + label">
            <option v-for="suggest in suggestions" :value="suggest" />
        </datalist>
        <template #invalid-message>
            <slot name="invalid-message" />
        </template>
        <template #icon>
            <slot name="icon" />
        </template>
    </FormComponent>
</template>

<script>
import FormComponent from "@/Components/Form/FormComponent.vue";
import {computed, ref} from "vue";
export default {
    name: "FormInput",
    emits: ['update:modelValue', 'focus', 'blur', 'input'],
    components: {FormComponent},
    props: {
        label: String,
        labelInset: Boolean,
        prefix: String,
        suffix: String,
        isInvalid: Boolean,
        isSuccess: Boolean,

        modelValue: null,
        min: Number,
        max: Number,
        id: String,
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: String,
        readonly: Boolean,
        required: Boolean,
        suggestions: Array,
    },
    setup (props, {emit}) {
        const focused = ref(false);

        const inputEditor = computed({
            get: () => {
                return props.modelValue;
            },
            set: (value) => {
                emit('update:modelValue', value);
                emit('input', value);
            }
        })

        const handleFocus = (e) => {
            focused.value = true;
            emit('focus', e);
        };

        const handleBlur = (e) => {
            focused.value = false;
            emit('blur', e);
        };

        const input = ref(null);

        const setFocus = () => {
            input.value.focus();
        }

        return {
            input,
            focused,
            inputEditor,
            handleFocus,
            handleBlur,
            setFocus,
        }
    },
}
</script>

<style scoped>
.arrow-up {
    @apply w-0 h-0;
    border-left: 8px transparent solid;
    border-right: 8px transparent solid;
    border-bottom: 8px theme('colors.red.500') solid;
    transform: translateY(-100%);
    top: 0;
    left: 2rem;
}
</style>
